import { render, staticRenderFns } from "./WellBeing.vue?vue&type=template&id=3e0b367a&"
import script from "./WellBeing.vue?vue&type=script&lang=ts&"
export * from "./WellBeing.vue?vue&type=script&lang=ts&"
import style0 from "./WellBeing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports